import { type StyledComponent } from '@emotion/styled'
import { Typography, type TypographyProps, styled } from '@mui/material'

export const TypographyDark: StyledComponent<TypographyProps> = styled(Typography)(({ theme }) => ({
  color: theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.common.black,
}))
